import { useEffect } from 'react';
import {
  getRootClassNames,
  SWAN_STYLE_KEY_MAP,
  SWAN_BASE_URL_MAP,
  SwanHead,
  SwanProvider,
} from '@vp/swan';

const eagerlyLoadedStyles = [SWAN_STYLE_KEY_MAP.button];

// TODO: Fix the 'children' is missing in props validation warning with TypeScript conversion

export const SwanConfiguration = ({ children }) => {
  const swanBaseUrl = SWAN_BASE_URL_MAP.default.cdn;
  const bodyClassName = getRootClassNames();

  useEffect(() => {
    const prevBodyClass = document.body.className;
    const prevHtmlClass = document.documentElement.className;
    document.body.className = `${bodyClassName}`;
    return () => {
      document.body.className = prevBodyClass;
      document.documentElement.className = prevHtmlClass;
    };
  }, [bodyClassName]);

  return (
    <SwanProvider swanBaseUrl={swanBaseUrl}>
      <SwanHead styleSheetKeys={eagerlyLoadedStyles} />
      {children}
    </SwanProvider>
  );
};
